import { render, staticRenderFns } from "./BlackGoldNoticePage.vue?vue&type=template&id=02dc783a"
import script from "./BlackGoldNoticePage.vue?vue&type=script&lang=js"
export * from "./BlackGoldNoticePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports